import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const scanSkippedRenderer = ({ changes: { location, skip_reason }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!location && (
        <Text color="grey800" display="block">
          At {location}
        </Text>
      )}
      {!!skip_reason && (
        <Text color="grey800" display="block">
          Reason: {skip_reason}
        </Text>
      )}
    </Spacer>
  );
};

export default scanSkippedRenderer;
